<div class="points-summary-bar d-flex justify-content-between align-items-center mt-2 d-lg-none">
  <!-- Back Button -->
  <div class="back-btn text-white cursor-pointer d-lg-none gloss-black" (click)="goBack()" >
    <span class="material-icons"> arrow_back_ios </span>
  </div>
  <!-- Points Bar -->
  <div class="justify-content-center flex-grow-1 flex-shrink-1 h-100">
    <fgb-points-summary></fgb-points-summary>
  </div>
</div>
